module.exports = __webpack_public_path__ + "img/hero-business.813aa36f.png";